/**
 * 裁剪场景的裁剪渲染区域边界，仅负责展示并继承裁剪图层容器的变换
 */
import React from 'react';

/**
 * 绘制裁剪期间的中间裁剪渲染区域边界
 *
 * @returns 不参与指针交互的蓝色边框节点
 */
const CropBoundary: React.FC = () => <div className="l-cropStage-boundary" aria-hidden="true" />;

export default CropBoundary;
